import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  },
});

/* =========================
   CONTENT (TEXT)
========================= */

export const getPublicContent = (page, lang) =>
  axios.get(`${API_BASE}/content`, {
    params: { page, lang },
  });

export const updateContentText = (contentId, payload) =>
  axios.put(
    `${API_BASE}/admin/content/${contentId}/text`,
    payload,
    authHeader()
  );

export const getAdminContentById = (contentId) =>
  axios.get(
    `${API_BASE}/admin/content/${contentId}`,
    authHeader()
  );

export const getAdminContentBySection = (page, section) =>
  axios.get(`${API_BASE}/admin/content/by-page`, {
    params: { page, section },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

export const createAdminContentItem = (payload) =>
  axios.post(`${API_BASE}/admin/content`, payload, authHeader());

/* =========================
   MEDIA (GLOBAL UPLOAD)
========================= */

export const uploadMedia = (file, { page, section }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("page", page);
  formData.append("section", section);

  return axios.post(
    `${API_BASE}/admin/media/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteMedia = (mediaId) =>
  axios.delete(
    `${API_BASE}/admin/media/${mediaId}`,
    authHeader()
  );

/* =========================
   CONTENT ↔ MEDIA
========================= */

export const attachMediaToContent = (contentId, mediaId) =>
  axios.post(
    `${API_BASE}/admin/content/${contentId}/media`,
    { mediaAssetId: mediaId },
    authHeader()
  );

export const removeMediaFromContent = (contentId, mediaId) =>
  axios.delete(
    `${API_BASE}/admin/content/${contentId}/media/${mediaId}`,
    authHeader()
  );

export const replaceContentMedia = (
  contentId,
  oldMediaId,
  file,
  { page, section }
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("page", page);
  formData.append("section", section);

  return axios.put(
    `${API_BASE}/admin/content/${contentId}/media/${oldMediaId}/replace`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
